import { isBrowser } from 'utils';

/**
 * Extracts voucher code from the URL query parameter 'voucher'.
 *
 * @returns The voucher code from the URL, or null/undefined if not present or not in a browser environment
 *
 * @example
 * // URL: https://example.com/products?voucher=SUMMER2024
 * const code = getVoucherFromUrl(); // Returns: 'SUMMER2024'
 *
 * @example
 * // URL: https://example.com/products
 * const code = getVoucherFromUrl(); // Returns: null
 *
 * @example
 * // Server-side (no window object)
 * const code = getVoucherFromUrl(); // Returns: undefined
 */
export function getVoucherFromUrl(): string | null | undefined {
  if (isBrowser()) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const voucher = urlParams.get('voucher');

    return voucher;
  }
}
